import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _TYPE_TO_MAPPER;

import _property from 'lodash/property';
import _curry from 'lodash/curry';
import _map from 'lodash/map'; // Constants

import SETUP_FIELDS_KEYS from '../../constants/accounting/setupFieldKeys'; // Formatters

import getDepartmentLabel from '../../formatters/departmentFormatter';
import getSetupFieldsLabel from '../../formatters/accounting/setupFieldsFormatter'; // TODO: need to read from constants later on.

var DEFAULT_MAPPER = {
  value: _property('id'),
  label: _property('name')
};
var DEPARTMENT_MAPPER = {
  value: _property('id'),
  label: getDepartmentLabel
};
var SETUP_FIELDS_MAPPER = {
  value: _property('id'),
  label: getSetupFieldsLabel
};
export var TYPE_TO_MAPPER = (_TYPE_TO_MAPPER = {}, _defineProperty(_TYPE_TO_MAPPER, SETUP_FIELDS_KEYS.DEPARTMENT, DEPARTMENT_MAPPER), _defineProperty(_TYPE_TO_MAPPER, SETUP_FIELDS_KEYS.FINANCIAL_STATEMENT_GROUP, SETUP_FIELDS_MAPPER), _defineProperty(_TYPE_TO_MAPPER, SETUP_FIELDS_KEYS.FINANCIAL_STATEMENT_SUB_GROUP, SETUP_FIELDS_MAPPER), _defineProperty(_TYPE_TO_MAPPER, SETUP_FIELDS_KEYS.ACCOUNT_SUBTYPE, SETUP_FIELDS_MAPPER), _TYPE_TO_MAPPER);

var mapCustomFieldToSelectOption = _curry(function (mapper, option) {
  var labelMapper = mapper.label;
  var valueMapper = mapper.value;
  return {
    label: labelMapper(option),
    value: valueMapper(option),
    additional: option
  };
});

var customFieldOptionMapper = function customFieldOptionMapper(type, options) {
  var mapper = TYPE_TO_MAPPER[type] || DEFAULT_MAPPER;
  return _map(options, mapCustomFieldToSelectOption(mapper));
};

export default customFieldOptionMapper;